import { objectToQueryString } from '@/utils/urlHelpers';

interface PrevAndNextLinks {
  prev?: string;
  next?: string;
}

/**
 * Generate next and prev link based on Logistics API response object.
 */
export default function getPrevAndNextLinks(
  currentUrlPath: string,
  responseData: { hasMore: boolean },
): PrevAndNextLinks {
  let next = '';
  let prev = '';
  let urlWithHost = currentUrlPath;

  if (!currentUrlPath.startsWith('http')) {
    urlWithHost = `https://example.com/${currentUrlPath}`;
  }

  const searchParams = new URL(urlWithHost).searchParams;

  if (searchParams.get('limit') === null) {
    return { next, prev };
  }

  if (responseData.hasMore) {
    const nextOffset = (Number(searchParams.get('offset')) || 0) + (Number(searchParams.get('limit')) || 0);
    const nextQueryParams = { ...Object.fromEntries(searchParams), offset: nextOffset };

    next = urlWithHost + '?' + objectToQueryString(nextQueryParams);
  }

  if (searchParams.get('offset') !== null) {
    const prevOffset = Number(searchParams.get('offset')) - Number(searchParams.get('limit') || 0);

    if (prevOffset >= 0) {
      const prevQueryParams = { ...Object.fromEntries(searchParams), offset: prevOffset };

      prev = urlWithHost + '?' + objectToQueryString(prevQueryParams);
    }
  }

  return { next, prev };
}
